// TEMPORARY: This file is for testing LINE Tag events on iOS.
// Remove this file once testing is complete. See #9936.

const LINE_TAG_ID = process.env.LINE_TAG_ID;

export function sendLineTagEvent(eventName: string): void {
  try {
    const _lt = (window as any)._lt;
    if (typeof _lt === 'function' && LINE_TAG_ID) {
      _lt('send', 'cv', { type: eventName }, [LINE_TAG_ID]);
    }
  } catch {
    // Silently ignore errors - this is non-critical test code
  }
}
